export const DNIEmailErrorResponse = {
    '0002': 'El número de DNI ingresado no está asociado a una cuenta.',
    '0003': 'El número de DNI ingresado no está asociado a una cuenta.',
    '0004': 'No encontramos un email asociado a este DNI. Intentá iniciar sesión con otro método.',
    '0005': 'No encontramos un email asociado a este DNI. Intentá iniciar sesión con otro método.',
};
